import { render, staticRenderFns } from "./BadContractDetails.vue?vue&type=template&id=94c3e6cc&scoped=true"
import script from "./BadContractDetails.vue?vue&type=script&lang=js"
export * from "./BadContractDetails.vue?vue&type=script&lang=js"
import style0 from "./BadContractDetails.vue?vue&type=style&index=0&id=94c3e6cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c3e6cc",
  null
  
)

export default component.exports